import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { Formik, Form, Field } from 'formik'
import { useSelector } from "react-redux";
import Cookies from "universal-cookie";
import Axios from 'axios'
import { useEffect, useState } from "react";

const queryArr = [
    { params: { opcion: "CICLOS_MORA" }, name: 'ciclos' },
    { params: { opcion: "CARGOS" }, name: 'cargos' },
    { params: { opcion: "RPT_SEDES" }, name: 'sedes' },
    { params: { opcion: "RPT_PLANES", Idsede: "07" }, name: 'planes' }
]

export default function MorosidadForm({ setRawData, setLoading }) {

    const cookies = new Cookies()
    //const url = cookies.get('__urlSchoolApi')
    const urlState = useSelector(state => state.url.urlSchoolApi)
    const url = urlState === '' || urlState === undefined || urlState === null ? cookies.get("__urlSchoolApi") : urlState

    const { headersAPI: headers } = useSelector(state => state.url)

    const [options, setOptions] = useState({});
    useEffect(() => {
        const fetchData = async () => {
            try {
                let resArr = await Promise.all(queryArr.map(q => (
                    Axios({
                        method: 'GET',
                        url: url + '/utils/busquedas',
                        headers,
                        params: q.params
                    })
                )))

                resArr = resArr.map(r => r.data)
                const resObj = queryArr.reduce((acc, q, i) => {
                    acc[q.name] = resArr[i]
                    return acc
                }, {})

                setOptions(resObj)
                setLoading(false)

            } catch (err) {
                console.log(err)
            }
        }

        fetchData()
    }, []) 


    //const [planes, setPlanes] = useState([])
    const handleSede = async (e, setFieldValue) => {

        setFieldValue('IdSede', e.target.value)

        try {
            const res = await Axios({
                method: 'GET',
                url: url + "/utils/busquedas",
                headers,
                params: {
                    opcion: "RPT_PLANES",
                    Idsede: e.target.value
                }
            })

            //setPlanes(res.data)
            setOptions(curr => ({
                ...curr,
                planes: res.data
            }))

        } catch (err) {
            console.log(err)
        }
    }

    const handleSubmit = async (values) => {
        setLoading(true)

        try {
            const res = await Axios({
                method: 'GET',
                url: url + "/reportes/morosidad",
                headers,
                params: { ...values, Opcion: "MOROSIDAD", NextM: 0 } 
            })

            setRawData(res.data.msg)
            setLoading(false)

        } catch (err) {
            console.log(err)
        }
    }

    const handleNextMonth = async (values) => {
        if (!values.IdCargo) return

        setLoading(true);
        try {
            const res = await Axios({
                method: 'GET',
                url: url + "/reportes/morosidad",
                headers,
                params: { ...values, Opcion: "MOROSIDAD", NextM: 1 }
            })

            setRawData(res.data.msg)
            setLoading(false)

        } catch (err) {
            console.log(err)
        }
    }

    return (
        <Formik
            initialValues={{ 
                //IdCiclo: '',
                IdSede: '00',
                IdCargo: '',
                IdPlan: '00'
            }}
            onSubmit={handleSubmit}
        >
            {
                ({ setFieldValue, values }) => {
                    return(
                        <Form>
                            <div className="bg-primarioMira px-4 py-5 shadow rounded-lg sm:p-6">
                                <div className="lg:grid lg:grid-cols-3 lg:gap-6">
                                    <div className="lg:col-span-1">
                                        <h3 className="text-lg font-medium leading-6 text-white">Filtros</h3>
                                        <p className="mt-1 text-sm text-grisMira">Seleccione los siguientes datos para generar el reporte de descuento reducido.</p>
                                    </div>
                                    <div className="mt-5 lg:col-span-2 lg:mt-0">
                                        <div className="grid grid-cols-8 gap-5">

                                            {/*<div className="col-span-8 lg:col-span-2">
                                                <label className="block text-sm font-medium text-grisMira">Ciclo</label>
                                                <Field name='IdCiclo' as='select' className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm">
                                                    <option value=''>---SELECCIONE UN CICLO---</option>
                                                    {
                                                        options?.ciclos?.map((ciclo) => 
                                                            <option key={ciclo.IdCiclo} value={ciclo.IdCiclo}>
                                                                {ciclo.IdCiclo}
                                                            </option>
                                                        )}
                                                </Field>
                                            </div>*/}

                                            <div className="col-span-8 lg:col-span-2">
                                                <label className="block text-sm font-medium text-grisMira">Sede</label>
                                                <Field
                                                onChange={e => handleSede(e, setFieldValue)} 
                                                name='IdSede' as='select' className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm">
                                                    {
                                                        options?.sedes?.map((sede) => 
                                                            <option key={sede.IdSede} value={sede.IdSede}>
                                                                {sede.Sede}
                                                            </option>
                                                        )}
                                                </Field>
                                            </div>

                                            <div className="col-span-8 lg:col-span-2">
                                                <label className="block text-sm font-medium text-grisMira">Plan</label>
                                                <Field name='IdPlan' as='select' className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm">
                                                    {
                                                        options?.planes?.map((plan) => 
                                                            <option key={plan.IdPlan} value={plan.IdPlan}>
                                                                {plan.NombrePlan}
                                                            </option>
                                                        )}
                                                </Field>
                                            </div>

                                            <div className="col-span-8 lg:col-span-2">
                                                <label className="block text-sm font-medium text-grisMira">Cargo</label>
                                                <Field name='IdCargo' as='select' className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm">
                                                    <option value=''>Todos los cargos</option>
                                                    {
                                                        options?.cargos?.map((cargo) => 
                                                            <option key={cargo.IdCargo} value={cargo.IdCargo}>
                                                                {cargo.Cargo}
                                                            </option>
                                                        )}
                                                </Field>
                                            </div>

                                            <div className="col-span-full lg:col-start-7 lg:col-end-9">
                                                <div className="flex justify-end pt-6">
                                                    <button
                                                        type="submit"
                                                        className="w-full inline-flex transition duration-500 ease justify-center rounded-md border border-transparent bg-secundario py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-secundarioMira hover:border-secundario hover:border-2 focus:outline-none focus:ring-1 focus:ring-white focus:ring-offset-2"
                                                    >
                                                        <div className="flex">
                                                            <MagnifyingGlassIcon className="h-5 w-5 text-white" aria-hidden="true" />
                                                            <p className="ml-1">Buscar</p>
                                                        </div>
                                                    </button>
                                                </div>
                                            </div>

                                            <div className="col-span-full lg:col-start-7 lg:col-end-9 row-start-2">
                                                <div className="flex justify-end pt-6">
                                                    <button
                                                        onClick={() => handleNextMonth(values)}
                                                        type="button"
                                                        className="w-full inline-flex justify-center rounded-md border border-transparent bg-azulBrillanteMira py-2 px-4 text-sm font-medium text-white shadow-sm transition duration-500 ease  hover:bg-secundarioMira hover:border-azulBrillanteMira  hover:border-2 focus:outline-none focus:ring-1 focus:ring-white focus:ring-offset-2"
                                                    >
                                                        <div className="flex">
                                                            {/*<MagnifyingGlassIcon className="h-5 w-5 text-white" aria-hidden="true" />*/}
                                                            <p className="ml-1">Siguiente mes</p>
                                                        </div>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Form>
                    )
                }
            }
        </Formik>

    )
}
